import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OuiButton } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiIconModule } from 'omnium-ui/icon';

@Component({
  selector: 'app-confirmation-depot-doc-dialog',
  standalone: true,
  imports: [OuiDialogModule, OuiButton, OuiIconModule],
  templateUrl: './confirmation-depot-doc-dialog.component.html',
  styleUrl: './confirmation-depot-doc-dialog.component.scss',
})
export class ConfirmationDepotDocDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ConfirmationDepotDocDialogComponent>);

  readonly data = inject(MAT_DIALOG_DATA);

  confirm() {
    this.dialogRef.close(true);
  }
}
